function set_modalback() {
	$('.container').append("<div class='modal-backdrop' role='dialog'></div>");
}

window.modal_basic_operations = function () {
	cross_button_action();
	show_loading_on_submit_or_back_button_click_on_modal();
}

window.show_company_count_div = function(company_count_div_selector) {
	$(company_count_div_selector).removeClass("hide-company-count");
}

window.hide_company_count_div = function(company_count_div_selector) {
	$(company_count_div_selector).addClass("hide-company-count");
}

window.update_company_count_text = function(company_count_text, company_count_div_selector) {
	$(company_count_div_selector).html(company_count_text);
}

window.show_loading_on_submit_or_back_button_click_on_modal = function () {
	$(".modal-bottom-buttons__last").on('click', function() { set_loading('.container'); });
	$(".modal-back-button").on('click', function() { set_loading('.container'); });
}

window.cross_button_action = function() {
	$(".modal-close-button").on('click', function(e) {
		e.preventDefault();
		if (window.confirm("現在の選択が解除されます。よろしいですか？")) {
			set_loading('.container');
			const url = "/form/step1/modal_close";
			$.ajax({ url, type: 'GET' });
		}
	});
}

window.customer_type_button_operation = function() {
	$("input[name='contact_forms_step1[customer_type]']").on("click", function() {
		$(".customer-type__button__submit")
			.removeClass("disabled").addClass("btn-primary").attr("disabled", false).text('次へ >');
		radio_button_background_color_change_operation(this.name);
	});
	if($("input[name='contact_forms_step1[customer_type]']:checked").length == 0){
		$(".customer-type__button__submit")
			.addClass("disabled").removeClass("btn-primary").attr("disabled", true).text("法人または個人を選択してください");
	}
}

$(function() {

	customer_type_button_operation();

	$(".customer-type__button__submit").on("click", function() {
		set_loading('.container');
	});

});